import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { KeyRound, X } from "lucide-react";

/** Promemoria al titolare: sta ancora usando il PIN di partenza, noto a chi ha configurato il locale. */
export const CambiaPin = () => {
  const { ownerPinDefault, user, demoMode, viewOnly } = useApp();
  const [chiuso, setChiuso] = useState(false);
  const nav = useNavigate();

  if (!ownerPinDefault || chiuso || demoMode || viewOnly || user?.role !== "titolare") return null;

  return (
    <div
      className="fixed bottom-[88px] left-3 right-3 z-[54] flex items-start gap-3 rounded-xl border border-amber-300 bg-amber-50 p-4 shadow-2xl lg:bottom-6 lg:left-auto lg:right-6 lg:w-[360px]"
      data-testid="cambia-pin-banner"
    >
      <div className="mt-0.5 shrink-0 rounded-lg bg-amber-500 p-2 text-slate-950">
        <KeyRound className="h-4 w-4" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-amber-950">Cambia il tuo PIN di partenza</p>
        <p className="mt-0.5 text-xs text-amber-900/80">
          Stai ancora usando il PIN assegnato all'attivazione: lo conosce anche chi ti ha configurato
          il locale. Con il tuo PIN si aprono incassi e impostazioni.
        </p>
        <div className="mt-3 flex items-center gap-2">
          <Button
            size="sm"
            onClick={() => { setChiuso(true); nav("/dipendenti"); }}
            data-testid="cambia-pin-vai-btn"
          >
            Cambialo adesso
          </Button>
          <button
            onClick={() => setChiuso(true)}
            data-testid="cambia-pin-dopo-btn"
            className="px-2 py-2 text-xs font-semibold text-amber-900/70"
          >
            Più tardi
          </button>
        </div>
      </div>
      <button onClick={() => setChiuso(true)} data-testid="cambia-pin-chiudi-btn" className="shrink-0 rounded-md p-1.5 text-amber-900/60">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
